import { render, staticRenderFns } from "./ServiceCustomer.vue?vue&type=template&id=7cc3c949&"
import script from "./ServiceCustomer.vue?vue&type=script&lang=js&"
export * from "./ServiceCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports